var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 17,
    viewBox: "0 0 27 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_124_60)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_124_60)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_124_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5374 10L19.1024 3.1C19.1283 2.98342 19.1277 2.86253 19.1007 2.74621C19.0737 2.62989 19.021 2.52109 18.9465 2.42778C18.872 2.33447 18.7775 2.25903 18.6701 2.20698C18.5626 2.15494 18.4448 2.12761 18.3254 2.127H5.28844L4.98444 0.637C4.94702 0.457191 4.84887 0.295733 4.70647 0.179739C4.56408 0.0637453 4.3861 0.000279752 4.20244 0L0.802441 0C0.590268 0 0.386785 0.0842855 0.236756 0.234315C0.0867269 0.384344 0.00244141 0.587827 0.00244141 0.8L0.00244141 1.331C0.00244141 1.43606 0.023134 1.54009 0.0633378 1.63715C0.103542 1.73421 0.162469 1.8224 0.236756 1.89669C0.386785 2.04671 0.590268 2.131 0.802441 2.131H3.12244L5.45444 13.531C5.11635 13.7249 4.84769 14.0201 4.68642 14.3749C4.52514 14.7297 4.47939 15.1262 4.55563 15.5084C4.63187 15.8906 4.82624 16.2392 5.1113 16.505C5.39635 16.7707 5.7577 16.9403 6.1443 16.9896C6.53091 17.0389 6.92324 16.9655 7.26589 16.7799C7.60855 16.5942 7.88422 16.3055 8.05398 15.9547C8.22374 15.6039 8.27901 15.2086 8.21199 14.8247C8.14496 14.4407 7.95903 14.0876 7.68044 13.815H14.6414C14.3593 14.0914 14.1726 14.4505 14.1083 14.8402C14.044 15.2299 14.1055 15.63 14.2839 15.9824C14.4623 16.3348 14.7482 16.6212 15.1004 16.8001C15.4525 16.979 15.8524 17.0412 16.2422 16.9775C16.632 16.9138 16.9914 16.7276 17.2683 16.446C17.5452 16.1643 17.7251 15.8018 17.7821 15.4109C17.839 15.0201 17.7701 14.6213 17.5851 14.2723C17.4001 13.9233 17.1088 13.6423 16.7534 13.47L16.9364 12.664C16.9623 12.5474 16.9617 12.4265 16.9347 12.3102C16.9077 12.1939 16.855 12.0851 16.7805 11.9918C16.706 11.8985 16.6115 11.823 16.5041 11.771C16.3966 11.7189 16.2788 11.6916 16.1594 11.691H7.24444L7.02744 10.629H16.7604C16.9421 10.628 17.1181 10.5651 17.2593 10.4508C17.4005 10.3365 17.4986 10.1775 17.5374 10Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_124_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.13,
    height: 17,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_124_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.13,
    height: 17,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_124_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.125,
    height: 17,
    fill: "white",
    transform: "translate(0.00244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCart);
export default __webpack_public_path__ + "static/media/img_cart.ef1b3a9b0d86721b20168f25edd8509a.svg";
export { ForwardRef as ReactComponent };